export default function landscapeModal() {
    if(typeof window.landscapeModalVisible == 'undefined') {
        window.landscapeModalVisible = false;
    }

    if (
        window.innerWidth < 961
        &&
        (
            window.matchMedia("(orientation: portrait)").matches
            ||
            window.innerHeight > window.innerWidth
        )
    ) {
        if(!window.landscapeModalVisible) {
            Swal.fire({
                iconHtml: '<img src="/_/img/orientation-icon.svg" alt="Phone Orientation Icon" width="80">',
                title: 'Landscape required',
                text: 'Please use landscape for better user experience',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });

            window.landscapeModalVisible = true;
        }
    } else {
        if(window.landscapeModalVisible) {
            Swal.close()

            window.landscapeModalVisible = false;
        }
    }
}